export const BOOTCAMP_QUESTIONS_REQUEST = "BOOTCAMP_QUESTIONS_REQUEST";
export const BOOTCAMP_QUESTIONS_SUCCESS = "BOOTCAMP_QUESTIONS_SUCCESS";
export const  BOOTCAMP_QUESTIONS_FAILURE = " BOOTCAMP_MODULES_FAILURE";